import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '../loader';

import { StyledButton } from './styles'

const Button = ({
  label,
  onClick,
  isDisabled,
  isLoading,
  outlineStyle,
  type,
  buttonSize,
  marginSize
}) => {
  return (
    <StyledButton
      type={type ? type : "button"}
      isDisabled={isDisabled}
      onClick={onClick}
      outlineStyle={outlineStyle}
      buttonSize={buttonSize}
      marginSize={marginSize}
    >
      {isLoading && <Loader isBlack={outlineStyle ? outlineStyle : false} />}
      {!isLoading && label}
    </StyledButton>
  );
};

export default Button;

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  outlineStyle: PropTypes.bool,
};

Button.defaultProps = {
  isDisabled: false,
  isLoading: false,
  outlineStyle: false,
  onClick: () => { },
};

